@let seatMapContainerWidth = seatMapContainerWidth$ | async;
@let seatMapWithStatusForFlight = seatMapWithStatusForFlight$ | async;
@let seatMapSvg = seatMapWithStatusForFlight?.seatMap?.svg | finSafe: 'html';
@let showMiniMap = seatMapWithStatusForFlight?.status === SeatMapStatus.OK && seatMapContainerWidth;

<div class="relative">
  <fcom-icon-button
    data-testid="carousel-prev"
    class="nav-button-control prev absolute ms-xsmall-l"
    [disabled]="isAtStart"
    [icon]="{ name: SvgLibraryIcon.ARROW_LEFT }"
    [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
    [size]="IconButtonSize.LARGE"
    [aria]="{ label: 'carousel.previous' | finLocalization }"
    (clickBtn)="scrollSeatMap('right')"
  />
  <div #seatMapWrapper class="seat-map-wrapper" data-testid="seat-map" (scroll)="handleScroll()">
    <div
      #seatMap
      tabindex="0"
      [innerHTML]="seatMapSvg"
      (keydown)="handleSeatKeyDown($event)"
      (click)="handleSeatClick($event)"
    ></div>
  </div>
  <fcom-icon-button
    data-testid="carousel-next"
    class="nav-button-control next absolute ms-xsmall-r"
    [disabled]="isAtEnd"
    [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT }"
    [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
    [size]="IconButtonSize.LARGE"
    [aria]="{ label: 'carousel.next' | finLocalization }"
    (clickBtn)="scrollSeatMap('left')"
  />
</div>

<div class="mr-small-t ps-small-y mini-map-wrapper">
  @if (showMiniMap) {
    <fin-seat-map-mini-map
      [viewPortWidth$]="seatMapContainerWidth$"
      [scrollPosition]="scrollPosition"
      [svgId]="svgId"
      [seatMapSvg]="seatMapSvg"
      (scrollTo)="scrollTo($event)"
      (keyScrollDirection)="scrollSeatMap($event)"
    />
  }
</div>
